import React from 'react'
import { ASSESSMENT_REPORT_NARRATIVE_SECTIONS } from 'src/mentor/components/AssessmentReport/assessmentReportSectionConfig'
import FreeFormRichTextView from 'src/mentor/components/EmrRelatedComponents/FreeFormRichText/FreeFormRichTextView'
import { PMPFooterContainer } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'

/** Build ordered section list for print: EMR order when provided, else config order */
function getOrderedSections(orderedSectionsForPrint) {
  if (Array.isArray(orderedSectionsForPrint) && orderedSectionsForPrint.length > 0) {
    return orderedSectionsForPrint
      .map((s) => ASSESSMENT_REPORT_NARRATIVE_SECTIONS.find((n) => n.id === s.id))
      .filter(Boolean)
  }
  return ASSESSMENT_REPORT_NARRATIVE_SECTIONS
}

export default function AssessmentReportBody({ reportData, orderedSectionsForPrint }) {
  const sectionsToRender = getOrderedSections(orderedSectionsForPrint)
  return (
    <>
      {/* Narrative sections in EMR order; print visibility from orderedSectionsForPrint (printable, !editorOnly) */}
      {sectionsToRender.map((section) => {
        const html = reportData?.[section.field]
        if (!html || (typeof html === 'string' && html.trim() === '')) return null
        const emrSection = orderedSectionsForPrint?.find((s) => s?.id === section.id)
        const isPrintableFromConfig = emrSection
          ? (emrSection?.selected !== false && emrSection?.printable !== false && emrSection?.editorOnly !== true)
          : true
        if (!isPrintableFromConfig) return null

        const sectionTitle = emrSection?.title ?? section.title
        const printTitleEnabled =
          emrSection?.printTitleEnabled ??
          emrSection?.emrSectionResponse?.section?.printTitleEnabled ??
          false
        const printTitle =
          emrSection?.printTitle ??
          emrSection?.emrSectionResponse?.section?.printTitle ??
          ''
        return (
          <FreeFormRichTextView
            key={section.id}
            html={html}
            displayTitle={sectionTitle}
            showTitle={printTitleEnabled}
            printTitleEnabled={printTitleEnabled}
            printTitle={printTitle}
            className={`assessment-report-section assessment-report-${section.id}`}
          />
        )
      })}
    </>
  )
}

export const AssessmentReportFooter = ({ reportData }) => {
  return (
    <PMPFooterContainer noColor={true}>
      <div
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '40%' }}
      >
        <div style={{ textAlign: 'right' }}>{reportData?.footer?.headline}</div>
        <div style={{ textAlign: 'right' }}>{reportData?.footer?.subtext}</div>
        <div style={{ textAlign: 'right' }}>{reportData?.footer?.supportText}</div>
      </div>
      <div
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '40%' }}
      >
        <div>{reportData?.footer?.headlineAlt}</div>
        <div>{reportData?.footer?.subtextAlt}</div>
        <div>{reportData?.footer?.supportTextAlt}</div>
      </div>
    </PMPFooterContainer>
  )
}
